import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Box from "../../../../common/box/Box";
import { Column, Row } from "../../../../common/columns";
import { InfoBarContext } from "../../../../common/info";
import Tooltip from "../../../../common/tooltip/Tooltip";
import { isTouch } from "../../../../utils/screenUtil";
import { cleanJoin } from "../../../../utils/stringUtil";
import RequestJournal from "./journal/Journal";

function RequestPreview({
  id,
  uid,
  title,
  statusColor,
  statusText,
  registryNumber,
  submissionDate,
  decisionStatusColor,
  decisionRegistryNumber,
  decisionReceiptDate,
  decisionConfirmationDate,
  solver,
  subject,
  blur,
  setActiveJournalId,
  className,
  renderRequestActions,
  renderDecisionActions,
  renderGeneralActions,
}) {
  const infoBar = useContext(InfoBarContext);
  const { t } = useTranslation();

  return (
    <Row
      isGapless={true}
      className={`${className} ${isTouch() ? "p-1" : ""} ${
        isTouch()
          ? "has-border-left-grey-1 has-border-right-grey-1 has-border-bottom-grey-1 has-border-top-grey-1"
          : "has-border-top-grey-2 has-border-bottom-grey-2 has-border-right-grey-2"
      }`}
      style={{
        opacity: blur ? 0.2 : 1,
        boxShadow: isTouch()
          ? "0 0.5em 1em -0.125em rgba(43, 43, 43, 0.1), 0 0px 0 1px rgba(43, 43, 43, 0.02)"
          : "",
      }}
    >
      <Column size={9}>
        <Box
          isShadowless={true}
          isRadiusless={true}
          isBorderless={true}
          statusIndicatorPosition={isTouch() ? "top" : "left"}
          statusIndicatorColor={statusColor}
          defaultPadding={false}
          className={cleanJoin(
            "mb-0",
            "has-border-bottom-grey-1",
            "has-border-right-grey-1",
            `${isTouch() ? "has-border-left-grey-1" : ""}`
          )}
        >
          <div className="level mb-0">
            <div className={`level-left`}>
              <div className="is-size-5">
                <strong>{title}</strong>
              </div>
            </div>
            <div className={`level-right`}>{renderRequestActions && renderRequestActions()}</div>
          </div>
          <Row className="mt-1 mt-0">
            {/*<Column size={2}>
              {t("requests.overview.preview.registryNumber")}: {registryNumber}
          </Column> */}
            <Column size={3}>
              {t("requests.overview.preview.submissionDate")}:{" "}
              {submissionDate === null ? " " : format(new Date(submissionDate), "dd.MM.yyyy HH:mm")}
            </Column>
          </Row>
        </Box>
        <Box
          isShadowless={true}
          isRadiusless={true}
          isBorderless={true}
          statusIndicatorPosition={isTouch() ? "top" : "left"}
          statusIndicatorColor={decisionStatusColor}
          defaultPadding={false}
          className={cleanJoin(
            "mt-1",
            !isTouch() ? "has-border-top-grey-1" : "",
            "has-border-right-grey-1",
            `${isTouch() ? "has-border-left-grey-1" : ""}`,
            `${
              decisionReceiptDate !== null && decisionReceiptDate !== ""
                ? ""
                : "has-text-grey-lighter"
            }`,
            `${isTouch() ? "has-border-bottom-grey-1" : ""}`
          )}
        >
          <div className="level mb-0">
            <div className={`level-left`}>
              <div className="is-size-5">{t("requests.overview.preview.decision.title")}</div>
            </div>
            <div className={`level-right`}>{renderDecisionActions && renderDecisionActions()}</div>
          </div>
          <Row className="mt-1">
            {/** Zakomentiran UrBroj na donjem boxu */}
            {/* <Column size={2}>
              {t("requests.overview.preview.decision.registryNumber")}: {decisionRegistryNumber}
            </Column> */}
            <Column size={3}>
              {t("requests.overview.preview.decision.receiptDate")}:{" "}
              {decisionReceiptDate ? format(new Date(decisionReceiptDate), "dd.MM.yyyy HH:mm") : ""}
            </Column>
            <Column size={3}>
              {t("requests.overview.preview.decision.confirmationDate")}:{" "}
              {decisionConfirmationDate
                ? format(new Date(decisionConfirmationDate), "dd.MM.yyyy HH:mm")
                : ""}
            </Column>
          </Row>
        </Box>
      </Column>
      <Column size={3}>
        <Box
          isShadowless={true}
          isRadiusless={true}
          isBorderless={true}
          defaultPadding={false}
          className={`p-0 ${isTouch() ? "has-border-grey-1 mt-1" : ""}`}
        >
          <Box
            isShadowless={true}
            isRadiusless={true}
            isBorderless={true}
            defaultPadding={true}
            className={`mb-0 has-border-bottom-white-1`}
          >
            <div className="is-size-5 is-pulled-left mr-4">{statusText}</div>
            <Tooltip
              content="Informacije o obradi zahtjeva"
              children={
                <FontAwesomeIcon
                  className="is-clickable is-pulled-right"
                  icon={faInfoCircle}
                  size="2x"
                  onClick={(e) => {
                    setActiveJournalId(uid);
                    infoBar.toggle(t("requests.overview.preview.journal.title"), () => (
                      <RequestJournal
                        id={id}
                        uid={uid}
                        subject={subject}
                        solver={solver}
                        statusText={statusText}
                      />
                    ));
                  }}
                />
              }
            ></Tooltip>
            {renderGeneralActions && renderGeneralActions()}
          </Box>
          <Box
            isShadowless={true}
            isRadiusless={true}
            isBorderless={true}
            defaultPadding={true}
            className="mt-6 has-border-top-white-1"
          >
            <div className="is-size-5 mt-5">
              <span>
                {t("requests.overview.preview.subject")}: {subject}
              </span>
              <br />
              <span>
                {t("requests.overview.preview.solver")}: {solver}
              </span>
            </div>
          </Box>
        </Box>
      </Column>
    </Row>
  );
}

export default RequestPreview;
